import { render, staticRenderFns } from "./EmpAgeRatioChart.vue?vue&type=template&id=1d98da42&"
import script from "./EmpAgeRatioChart.vue?vue&type=script&lang=js&"
export * from "./EmpAgeRatioChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports